// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "footer-module--base-text-alt--global--4088c";
export var baseTextGlobal = "footer-module--base-text--global--6c097";
export var blockSpacing100 = "footer-module--block-spacing-100--b3949";
export var blockSpacing50 = "footer-module--block-spacing-50--bb00a";
export var blockVPadding100 = "footer-module--block-v-padding-100--b871e";
export var blockVPadding50 = "footer-module--block-v-padding-50--7cfa3";
export var captionTextGlobal = "footer-module--caption-text--global--f1131";
export var cmsRenderedContentGlobal = "footer-module--cms-rendered-content--global--22fbe";
export var container = "footer-module--container--3d4c5";
export var cookieConsent = "footer-module--cookieConsent--ccd8e";
export var copyrightStatement = "footer-module--copyrightStatement--cfab5";
export var defaultHSpacingGlobal = "footer-module--default-h-spacing--global--02f7a";
export var fadeInAnimation = "footer-module--fadeInAnimation--e69a3";
export var fadeInOnLoadGlobal = "footer-module--fade-in-on-load--global--db76d";
export var footerLinks = "footer-module--footerLinks--4c9ba";
export var fullHeightGlobal = "footer-module--full-height--global--a6bba";
export var fullHeightOmittingNavGlobal = "footer-module--full-height-omitting-nav--global--0d8b1";
export var headingTextGlobal = "footer-module--heading-text--global--9e5d7";
export var ingressTextGlobal = "footer-module--ingress-text--global--99f15";
export var linkColorChangeTransitionGlobal = "footer-module--link-color-change-transition--global--e7e15";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "footer-module--page-heading-text--global--62e87";
export var paragraphTextGlobal = "footer-module--paragraph-text--global--58984";
export var privacyStatement = "footer-module--privacyStatement--a648f";
export var socialLink = "footer-module--socialLink--889d7";
export var socialLinks = "footer-module--socialLinks--35d50";
export var subheadingTextGlobal = "footer-module--subheading-text--global--a4b70";